<template>
    <UserWrapper :extraWidth="false" :showTitleContainer="false">
      <ScoutJob v-if="canShowScoutPopUp" @scouted="refreshScoutCount" />
      <template v-if="loading || !accessChecked">
        <Loader />
      </template>
      <div class="job-listing-container" v-else>
        <JobLists
          ref="jobLists"
          :showMatchedJobs="showMatchedJobs"
          :searchKeyword="searchKeyword"
          :companies="companies"
          :initialCompanyId="initialCompanyId"
          @search="searchKeyword = $event"
          @toggle-change="handleToggleChange"
        />
      </div>
      <template v-slot:footer>
        <Footer/>
      </template>
    </UserWrapper>
</template>

<script>
import UserWrapper from "../UserWrapper.vue";
import JobLists from "./JobLists.vue";
import Loader from "../Loader.vue";
import Footer from "../Footer.vue";
import ScoutJob from "./ScoutJob.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "JobListings",
  components: { UserWrapper, JobLists, Loader, Footer, ScoutJob },
  data() {
    return {
      showMatchedJobs: true,
      searchKeyword: "",
      isClientSideSearch: true,
      loading: true,
      accessChecked: false,
    };
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
      isProfileLoaded: "getIsProfileLoaded",
      companies: "getCompanies",
    }),
    initialCompanyId() {
      return this.$route.query.company_id || null;
    },
    canShowScoutPopUp() {
      const hasViewedPopup = localStorage.getItem('hasViewedScoutPopup');
      const isSourceCompanyScoutOn = this.profile.company_scout_profile === true;
      const isDirectBloomRegistration = !this.profile.company_id;
      return (
        Object.keys(this.profile).length > 0 &&
        (isSourceCompanyScoutOn || isDirectBloomRegistration) &&
        this.profile.activity &&
        this.profile.activity.isFirstLogin &&
        !hasViewedPopup
      );
    },
  },
  methods: {
    ...mapActions({
      setProfile: "setProfile",
      companiesList: "companiesList",
    }),
    handleToggleChange(newValue) {
      this.showMatchedJobs = newValue;
      // this.searchKeyword = "";
    },
    searchJobs() {
      // Implement search functionality
      console.log("Searching for:", this.searchKeyword);
      console.log("Show matched jobs only:", this.showMatchedJobs);
    },
    /** Called e.g. from header; actual search runs in JobLists on Enter / suggestion select */
    handleSearch() {
      this.$refs.jobLists.handleSearch();
    },
    /** ScoutJob (the initial pickup-jobs popup) scouts independently of JobLists'
     * own ticket-count state — refresh it here so "残りX枚" updates immediately. */
    refreshScoutCount() {
      if (this.$refs.jobLists) {
        // also reloads the scouted list so that company's scout buttons grey out immediately
        this.$refs.jobLists.getJobseekerScoutedJobs();
      }
    },
    async checkAccess() {
      try {
        if (!this.isProfileLoaded) {
          await this.setProfile();
        }

        const profile = this.profile;
        const hasAccess = Object.keys(profile).length > 0 
        
        if (!hasAccess) {
          return this.$router.push('/');
        }

        // if (profile.company_scout_profile !== true) {
        //   return this.$router.replace('/');
        // }

        this.accessChecked = true;
        if (!this.companies || this.companies.length === 0) {
          await this.companiesList();
        }
        // this.loading = false;
      } catch (error) {
        console.error('Failed to check access:', error);
        // this.loading = false;
        this.$router.push('/');  // Redirect on error
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.checkAccess();
  }
};
</script>

<style scoped>
>>> .profile-detail-block {
  background-color: #E7F6F6 !important;
}
/* Notice text styles */
.notice-text {
  background-color: #F9FAFB;
  color: #3C3C3C;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;
  border-radius: 10px;
  height: 47px;
  padding: 0 10px;
}
.br-sm { display: inline; }

@media screen and (max-width: 576px) {
  
  .job-listing-container .notice-text {
    font-size: 12px !important;
    height: 80px !important;
  }
}
</style>
